module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_04_6NV26_1SA_G1W.f2c838e8.png";